import { createFileRoute } from '@tanstack/react-router';
import ApiTriggeredTab from '@/pages/workspaces/broadcasts/api-triggered/index.page';
import { RumPageRendered } from '@/services/rum/use-page-rendered';
import { ApiTriggeredTabGuard } from '@/pages/workspaces/broadcasts/routing';
import { validateApiTriggeredSearch } from '@/pages/workspaces/broadcasts/url-state';

function ApiTriggeredRoute() {
  return (
    <ApiTriggeredTabGuard>
      <RumPageRendered>
        <ApiTriggeredTab />
      </RumPageRendered>
    </ApiTriggeredTabGuard>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/broadcasts/api-triggered')({
  component: ApiTriggeredRoute,
  validateSearch: validateApiTriggeredSearch,
});
